import {Component} from '@angular/core';
import {NavigationEnd, Router, RouterLink} from '@angular/router';
import {filter} from 'rxjs/operators';
import {AusschreibungService} from '../../service/ausschreibung.service';

@Component({
    imports: [RouterLink],
    selector: 'dah-breadcrumb-nav',
    templateUrl: './breadcrumb-nav.component.html',
    standalone: true
})
export class BreadcrumbNavComponent {
  selectedAusschreibungTitle = '';
  id = '-1';
  angebot = false;
  signedIn = false;
  onAngebot = false;
  onAusschreibung = false;

  constructor(
    private ausschreibungService: AusschreibungService,
    private router: Router,
  ) {
    this.ausschreibungService.isSignedIn().subscribe(signedIn => this.signedIn = signedIn);

    this.ausschreibungService.get().subscribe(next => {
      if (!next) return;
      this.selectedAusschreibungTitle = next.objekt ?? '';
      this.id = next.id ?? '-1';
      this.angebot = next.angebot !== undefined;
    });

    this.updateLevel(this.router.url);
    this.router.events.pipe(
      filter((e): e is NavigationEnd => e instanceof NavigationEnd),
    ).subscribe(e => this.updateLevel(e.urlAfterRedirects));
  }

  private updateLevel(url: string): void {
    const path = url.split(/[?#]/)[0];
    this.onAngebot = path.startsWith('/angebot');
    this.onAusschreibung = path.startsWith('/ausschreibung');
  }
}
